import React, { useEffect, useState } from 'react'
import { Modal } from 'antd'
import { listSharedStoryboards } from '../../../UserDashboard/storyboardApi'

// Read-only storyboard images for invited collaborators. No download, edit, delete, generation or AI credits.
const SharedStoryboardViewer = ({ scriptId, open, onClose }) => {
    const [state, setState] = useState({ loading: true, storyboards: [], error: '' })
    useEffect(() => {
        if (!open) return
        let live = true
        setState({ loading: true, storyboards: [], error: '' })
        listSharedStoryboards(scriptId)
            .then((d) => live && setState({ loading: false, storyboards: d.storyboards || [], error: '' }))
            .catch((e) => live && setState({ loading: false, storyboards: [], error: e.message || 'Storyboards could not be loaded.' }))
        return () => { live = false }
    }, [open, scriptId])
    return (
        <Modal open={open} onCancel={onClose} footer={null} centered width={900} title='Storyboards (View Only)'>
            {state.loading && <p>Loading storyboards…</p>}
            {state.error && <p role='alert' className='text-red-600'>{state.error}</p>}
            {!state.loading && !state.error && state.storyboards.length === 0 && <p>No storyboards have been shared for this script yet.</p>}
            <div className='flex flex-col gap-6 max-h-[70vh] overflow-y-auto' onContextMenu={(e) => e.preventDefault()}>
                {state.storyboards.map((s) => (
                    <section key={s.id}>
                        <h3 className='font-semibold'>{s.sceneNumber ? `Scene ${s.sceneNumber} — ` : ''}{s.sceneHeading}</h3>
                        {s.expired ? <p>These storyboard images have expired.</p> : (
                            <div className='grid grid-cols-1 sm:grid-cols-2 gap-3 mt-2'>
                                {s.frames.map((f, i) => (
                                    <figure key={i}>
                                        {s.srcs[i] && <img src={s.srcs[i]} alt={f.shot || `Frame ${i + 1}`} draggable={false} className='w-full rounded' />}
                                        <figcaption className='text-sm mt-1'><p><strong>Shot:</strong> {f.shot}</p><p><strong>Action:</strong> {f.action}</p><p><strong>Camera:</strong> {f.camera}</p></figcaption>
                                    </figure>
                                ))}
                            </div>
                        )}
                    </section>
                ))}
            </div>
        </Modal>
    )
}
export default SharedStoryboardViewer
